import { apiClient } from '../client'
import type {
  ActivityFeedResponseDto,
  ActivityActorsResponseDto,
} from '@/types'

export interface GetActivityFeedParams {
  days?: number
  actorUserId?: string
}

export function getActivityFeed(
  params: GetActivityFeedParams = {}
): Promise<ActivityFeedResponseDto> {
  const searchParams = new URLSearchParams()
  if (params.days !== undefined) searchParams.set('days', String(params.days))
  if (params.actorUserId) searchParams.set('actorUserId', params.actorUserId)
  const qs = searchParams.toString()
  return apiClient.get<ActivityFeedResponseDto>(`/api/v2/activity${qs ? `?${qs}` : ''}`)
}

export function getActivityActors(): Promise<ActivityActorsResponseDto> {
  return apiClient.get<ActivityActorsResponseDto>('/api/v2/activity/actors')
}

export function getActivityItemPdfUrl(id: string): Promise<{ url: string; expiresInSeconds: number }> {
  return apiClient.get<{ url: string; expiresInSeconds: number }>(`/api/v2/activity/${id}/pdf-url`)
}
